import React from "react";

const SecurityIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0003 6.91671V8.75004M10.9985 2.33337C8.24113 2.33337 6.45363 4.18412 4.3398 4.85879C3.47997 5.13379 3.05005 5.27037 2.87588 5.46379C2.70172 5.65629 2.6513 5.93954 2.54955 6.50421C1.45872 12.5505 3.84205 18.1404 9.52538 20.3165C10.135 20.5503 10.4402 20.6667 11.0012 20.6667C11.5622 20.6667 11.8684 20.5494 12.4789 20.3156C18.1613 18.1404 20.5419 12.5505 19.451 6.50421C19.3493 5.93954 19.298 5.65629 19.1238 5.46287C18.9496 5.26946 18.5206 5.13287 17.6608 4.85879C15.5461 4.18412 13.7558 2.33337 10.9985 2.33337Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SecurityIcon;
